import React, { useEffect, useState } from 'react'
import '../styles/navbar.css';
import { MdOutlineHome } from "react-icons/md";
import { LuLibrary } from "react-icons/lu";
import { BiMessageDetail } from "react-icons/bi";
import { SiAboutdotme } from "react-icons/si";
import { NavLink } from 'react-router-dom';
import slide from '../audio/slide.mp3'
import { motion, AnimatePresence } from "framer-motion";

function NavBar() {

  const [show, setShow] = useState(true);      // Controls display
  const [fadeOut, setFadeOut] = useState(false); // Controls fade

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const documentHeight = document.body.scrollHeight;
      const distanceFromBottom = documentHeight - scrollPosition;

      if (distanceFromBottom <= 100) {
        setFadeOut(true); // Trigger fade out
      } else {
        setFadeOut(false); // Trigger fade in
        setShow(true);     // Show immediately on scroll up
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const variants = {
    visible: { opacity: 1, transition: { duration: 0.4 } },
    hidden: {
      opacity: 0,
      transition: { duration: 0.4 },
      transitionEnd: {
        display: "none",
      },
    },
  };
  
const audio = new Audio(slide);
const soundEffect=()=>{
    audio.play().catch(function (error) {
    console.log("Sound error")});
}

    return (
        <AnimatePresence>
      {show && (
        <motion.div
          initial="visible"
          animate={fadeOut ? "hidden" : "visible"}
          variants={variants}
          onAnimationComplete={() => {
            if (fadeOut) setShow(false); // Actually hide after fade
          }} className='glass-btn navbar '>
            <ul>

                <NavLink to="/" onClick={soundEffect}
                    className={({ isActive, isPending }) =>
                        isPending ? "pending nav_list" : isActive ? "active nav_list" : "nav_list"
                    }>

                    <div className="nav_down"><MdOutlineHome className='nav_icon' /></div>
                    <div className="nav_up">Home</div>

                </NavLink>

                <NavLink to="/library" onClick={soundEffect}
                    className={({ isActive, isPending }) =>
                        isPending ? "pending nav_list" : isActive ? "active nav_list" : "nav_list"
                    }>

                    <div className="nav_down"><LuLibrary className='nav_icon' /></div>
                    <div className="nav_up">Library</div>

                </NavLink>

                <NavLink to="/contact" onClick={soundEffect}
                    className={({ isActive, isPending }) =>
                        isPending ? "pending nav_list" : isActive ? "active nav_list" : "nav_list"
                    }>

                    <div className="nav_down"><BiMessageDetail className='nav_icon' />
                    </div>       <div className="nav_up">Contact</div>

                </NavLink>


                <NavLink to="/about" onClick={soundEffect}
                    className={({ isActive, isPending }) =>
                        isPending ? "pending nav_list" : isActive ? "active nav_list" : "nav_list"
                    }>

                    <div className="nav_down"><h3>me</h3></div>
                    <div className="nav_up">About</div>

                </NavLink>
                <div className="nav_ball"></div>
            </ul>
           </motion.div>
      )}
    </AnimatePresence>
    )
}

export default NavBar
